import { ImageWrapper } from "@/lib/styles";
import styled from "styled-components";

export const Wrapper = styled(ImageWrapper)`
  padding-bottom: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`;
